<div class="content">
    <h2>Designed in the Details</h2>
    <div class="items">
        <div class="item" showleft [showDelay]="50">
            <img ngSrc="/images/home/soft.png" width="100" height="100">
            <div class="texts">
                <h4>Soft-touch lace</h4>
                <p>Premium lace that feels as beautiful as it looks.</p>
            </div>
        </div>
        <div class="item" showleft [showDelay]="150">
            <img ngSrc="/images/home/flattering.png" width="100" height="100">
            <div class="texts">
                <h4>Flattering silhouettes</h4>
                <p>Designed to enhance your natural shape.</p>
            </div>
        </div>
        <div class="item" showleft [showDelay]="250">
            <img ngSrc="/images/home/layer.png" width="100" height="100">
            <div class="texts">
                <h4>Made to layer</h4>
                <p>versatile pieces that style your way, all day or night.</p>
            </div>
        </div>
    </div>
</div>